import React from 'react';
import { CATEGORIES, ROLES, STAGES, isFounder, servesCompanies, toggle } from '../lib/taxonomy';

/* Shared between the profile editor and first-run setup, so the two can never
   drift into asking the same question differently. Each takes the profile and
   an `onChange(patch)`; saving is the caller's business. */

function Chips({ options, selected, onToggle }) {
  return (
    <div className="pe-chips">
      {options.map((value) => (
        <button
          key={value} type="button"
          className={`fchip${(selected || []).includes(value) ? ' on' : ''}`}
          onClick={() => onToggle(value)}
        >
          {value}
        </button>
      ))}
    </div>
  );
}

export function RoleStageFields({ profile, onChange, anchors = false }) {
  const roles = profile.role_tags || [];
  // Roles the assistant wrote ("engineer", "architect") stay visible and removable.
  const extra = roles.filter((r) => !ROLES.includes(r));

  return (
    <>
      <div className="pe-field" id={anchors ? 'pf-role_tags' : undefined}>
        <label className="flabel">What best describes you</label>
        <Chips
          options={[...ROLES, ...extra]}
          selected={roles}
          onToggle={(r) => onChange({ role_tags: toggle(roles, r) })}
        />
        <p className="pe-hint">Pick any that apply. This is how founders find advisors, and the other way round.</p>
      </div>

      {isFounder(roles) && (
        <div className="pe-field">
          <label className="flabel">Company stage</label>
          <Chips
            options={STAGES}
            selected={profile.stage ? [profile.stage] : []}
            onToggle={(s) => onChange({ stage: profile.stage === s ? '' : s })}
          />
        </div>
      )}

      {servesCompanies(roles) && (
        <div className="pe-field">
          <label className="flabel">Stages you work with</label>
          <Chips
            options={STAGES}
            selected={profile.stages_served}
            onToggle={(s) => onChange({ stages_served: toggle(profile.stages_served, s) })}
          />
          <p className="pe-hint">The companies you are most useful to. Founders at these stages rank higher for you.</p>
        </div>
      )}
    </>
  );
}

export function CategoryField({ profile, onChange, anchors = false }) {
  return (
    <div className="pe-field" id={anchors ? 'pf-categories' : undefined}>
      <label className="flabel">Categories</label>
      <Chips
        options={CATEGORIES}
        selected={profile.categories}
        onToggle={(c) => onChange({ categories: toggle(profile.categories, c) })}
      />
      <p className="pe-hint">
        Seeds your feed before it has learned anything, and most introductions start from one
        you share. Missing one you need? Tell us and we'll add it.
      </p>
    </div>
  );
}
